module.exports = __webpack_public_path__ + "img/b6.54d784d3.png";